import { MAX_CUSTOM_EDGE } from "../../functions/src/shared/imageGeneration";
import type { TFunction } from "i18next";
import { AppError } from "./appError";

/**
 * Resolves an error to a user-friendly, translated message.
 *
 * - `AppError` instances are mapped via their `code` to an i18n key under the
 *   `errors` namespace (e.g. `errors.credits/insufficient`).
 * - Everything else falls back to the generic `errors.unknown` message.
 *
 * The raw `error.message` is **never** returned — it goes to Sentry only.
 */
export function resolveErrorMessage(error: unknown, t: TFunction): string {
  if (error instanceof AppError) {
    const key = `errors.${error.code}`;
    const resolved = t(key, { defaultValue: "", max: MAX_CUSTOM_EDGE });
    if (resolved && resolved !== key) {
      return resolved;
    }
  }
  return t("errors.unknown");
}
